module.exports = __webpack_public_path__ + "static/media/400406_01.9e3a6c34.png";